import React, { useContext, useEffect, useState } from "react";
import classes from "./Services.module.css";
import AuthContext from "../../store/auth-context";
import Helpers from "../../utils/Helpers";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/img";
import RemoteConfig from "../../services/RemoteConfig";
import BookNowBtn from "../BookNowBtn";
import "../../index.css";
import MainCarousel from "../Carousel/Carousel";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const SERVICES = [
  {
    image: images.nail12,
    title: "Manicure",
    description:
      "A classic service to keep your hands looking elegant and well cared for. Featuring nail shaping, cuticle care, and a soft finish with your choice of color, this treatment leaves your hands refined and beautiful.",
  },
  {
    image: images.nail13,
    title: "Pedicure",
    description:
      "A soothing treatment designed to refresh and restore your feet. Includes nail and cuticle care, gentle skin softening, and a relaxing massage, leaving your feet smooth, polished, and rejuvenated.",
  },
  {
    image:  images.nail03,
    title: "BIAB (Builder in a Bottle)",
    description:
      "A strengthening gel treatment that enhances and protects natural nails while maintaining a lightweight, natural look. Perfect for anyone seeking durability and long-lasting elegance without heavy extensions.",
  },
  {
    image: images.nail06,
    title: "Acrylic",
    description:
      "A timeless enhancement that offers strength, durability, and endless style possibilities. Acrylic nails provide a polished finish and can be shaped to suit your personal look, from classic to bold designs.",
  },
  {
    image: images.nail05,
    title: "Nail Design",
    description:
      "A creative service that lets you express your individuality through artful nail styles. From subtle elegance to bold statements, our skilled technicians craft designs tailored to your taste with precision and care.",
  },
];

const Services = (props) => {
  const navigate = useNavigate();
  const isMobile = useCheckIsMobile();

  const renderServices = () => {
    function chunkArray(arr, chunkSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    }

    const chunkedServiceArray = chunkArray(SERVICES, isMobile ? 1 : 3);

    return chunkedServiceArray.map((serviceGroup, index) => {
      return (
        <div className={classes.servicesRow} key={`service-${index}`}>
          {serviceGroup.map(({ title, description, image }, index) => {
            return (
              <div className={classes.serviceItem} key={`${index}-${title}`}>
                <div
                  style={{
                    borderTopLeftRadius: "100%",
                    borderTopRightRadius: "100%",
                    borderWidth: "1px",
                    borderColor: "red",
                    padding: "1px",
                    backgroundColor: "#000",
                  }}
                >
                  <img className={classes.serviceImg} alt={title} src={image} />
                </div>

                <div className={classes.serviceItemTextContainer}>
                  <h2>{title}</h2>
                  <h4>{description}</h4>
                </div>
              </div>
            );
          })}
        </div>
      );
    });
  };

  return (
    <div ref={props?.serviceRef} className={classes.wrapper}>
      <h1 className={classes.title}>Our Services</h1>

      <MainCarousel>{renderServices()}</MainCarousel>

      <BookNowBtn
        style={classes.priceListBtn}
        onClick={() => navigate("/services")}
        title={"VIEW PRICING"}
      />
    </div>
  );
};

export default Services;
